import type { EntityKind } from './types'

import { DirectoryPage, PlayerProfilePage, TeamProfilePage } from './pages'

interface DirectoryRouteHandle {
  useSearch: () => { q: string, type: EntityKind, page: number }
}

interface TeamRouteHandle {
  useParams: () => { teamId: string }
  useSearch: () => { playerPage: number, back?: string }
}

interface PlayerRouteHandle {
  useParams: () => { playerId: string }
  useSearch: () => { appearancePage: number, at?: string, back?: string }
}

export function DirectoryRouteKernel({ route }: { route: DirectoryRouteHandle }) {
  return <DirectoryPage search={route.useSearch()} />
}

export function TeamProfileRouteKernel({ route }: { route: TeamRouteHandle }) {
  const params = route.useParams()
  const search = route.useSearch()
  return <TeamProfilePage teamId={params.teamId} playerPage={search.playerPage} back={search.back} />
}

export function PlayerProfileRouteKernel({ route }: { route: PlayerRouteHandle }) {
  const params = route.useParams()
  const search = route.useSearch()
  return <PlayerProfilePage playerId={params.playerId} appearancePage={search.appearancePage} at={search.at} back={search.back} />
}
